import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_key_language",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row g-9" }
const _hoisted_9 = { class: "row align-items-end g-9" }
const _hoisted_10 = { class: "col-md-9 fv-row" }
const _hoisted_11 = { class: "col-md-3 fv-row" }
const _hoisted_12 = { class: "modal-footer flex-center" }
const _hoisted_13 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_14 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "addLanguageKeyForm",
          model: _ctx.addLanguageKeyData
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.ADD')} ${_ctx.$t('message.LANGUAGE')} ${_ctx.$t('message.KEY')}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_Input, {
                    type: "text",
                    name: "locale_key",
                    label: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.KEY')}`,
                    placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.KEY')}`,
                    requiredMsg: `${_ctx.$t('message.KEY')} ${_ctx.$t('message.IS_REQUIRED')}`,
                    locale_key: _ctx.addLanguageKeyData.locale_key,
                    "onUpdate:locale_key": _cache[1] || (_cache[1] = ($event: any) => (_ctx.addLanguageKeyData.locale_key = $event)),
                    target: "locale_key",
                    required: true,
                    value: _ctx.addLanguageKeyData.locale_key
                  }, null, 8, ["label", "placeholder", "requiredMsg", "locale_key", "value"])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Input, {
                      name: "translation",
                      label: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.TRANSLATION')}`,
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.TRANSLATION')}`,
                      requiredMsg: `${_ctx.$t('message.TRANSLATION')} ${_ctx.$t('message.IS_REQUIRED')}`,
                      translation: _ctx.addLanguageKeyData.translation,
                      "onUpdate:translation": _cache[2] || (_cache[2] = ($event: any) => (_ctx.addLanguageKeyData.translation = $event)),
                      target: "translation",
                      required: true,
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateValue(_ctx.addLanguageKeyData.translation))),
                      value: _ctx.addLanguageKeyData.translation
                    }, null, 8, ["label", "placeholder", "requiredMsg", "translation", "value"])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_Select, {
                      name: "locale",
                      target: "locale",
                      callEmit: true,
                      required: false,
                      label: false,
                      locale: _ctx.locale,
                      "onUpdate:locale": _cache[4] || (_cache[4] = ($event: any) => (_ctx.locale = $event)),
                      selectData: _ctx.locales,
                      value: _ctx.locale,
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
                    }, null, 8, ["locale", "selectData", "value"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("button", _hoisted_13, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}